'use client'

import { useEffect } from 'react'
import { useTheme } from '@/contexts/ThemeContext'

export default function ThemeManager() {
  const { theme } = useTheme()

  // 테마 변경 시 DOM에 클래스 적용 (ThemeContext와 동기화)
  useEffect(() => {
    const root = document.documentElement

    if (theme === 'dark') {
      root.classList.remove('light')
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
      root.classList.add('light')
    }
  }, [theme])

  return null
}
